import { ImportError } from './ImportError'

/**
 * Error that is thrown when a import value is not a valid number.
 */
export class ImportNumberError extends ImportError {
  constructor(message: string) {
    super(message)
    this.name = 'ImportNumberError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
